export const readableAssetType = (assetType: string | undefined | null) => {
  switch (assetType) {
    case 'IHS&IMS':
      return 'hoog- en middenspanning';
    case 'hoogspanning':
      return 'IHS';
    case 'IMS':
      return 'Middenspanning';
    default:
      return 'Onbekend';
  }
};
